<template>
  <div class="dealtbox">
    <drag-modal :visible="putVisible" :title='edit==0?"查看":(edit==1?"新增":"编辑")' width='410px' class="disform" @cancel='rest'  :zIndex="1003">
      <div class="intopbtn"  v-if="is_complete==0">
        <a href="javascript:void(0);" @click="edit=edit==1?0:1">{{edit==0?'修改':'取消修改'}}</a>
        <a href="javascript:void(0);" @click="isok(form.id)" style="margin-left:10px;">完成</a>
      </div>
      <a-form-model ref="forms" :rules="rules" :model="form" :label-col="{span: 5}" :wrapper-col="{span:18 }">
        <a-form-model-item label="标题" prop="title" :rules="{ required: true, message: '请输入标题',trigger: 'blur'}">
          <a-input v-model="form.title" placeholder="请输入" :disabled='edit==0' />
        </a-form-model-item>
        <a-form-model-item label="待办内容" prop="content" :rules="{ required: true, message: '请输入待办内容',trigger: 'blur'}">
          <Ntxt :content='form.content' :max='1000' Hei='108px' @contentVal='(e)=>{form.content=e}' :edit='edit==0'></Ntxt>
        </a-form-model-item>
        <a-form-model-item label="提醒时间" prop="remind_time" :rules="{ required: true, message: '请选择提醒时间',trigger: 'change'}">
          <a-date-picker v-model="form.remind_time" placeholder="请选择" show-time style="width: 100%;" type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' :disabled='edit==0' />
        </a-form-model-item>
        <a-form-model-item v-if='edit!=0'>
          <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="confirm">
            <a-button type="primary" style="width: 133px;height: 32px;margin:0 0 0 80px;">
              确定
            </a-button>
          </a-popconfirm>
        </a-form-model-item>
      </a-form-model>
    </drag-modal>
    <Month ref="monthbox"></Month>
    <img src='@/assets/img/today.png' height='16'/>
    <div class="html">
      <!-- {{ message }} -->
      <a-carousel dot-position="right" :dots="false" autoplay >
        <div v-for="i in message" class="a">{{ i.title }}</div>
      </a-carousel>
      <div class="nomess" v-if="message.length==0">暂无消息</div>
    </div>
    <div class="month">
      <div class="tp">
        <span>{{cur | Ym}}</span>
        <a href='javascript:void(0);' @click="more">更多</a>
      </div>
      <div class="week">
        <div class="li" v-for='i in week' :class="{'now':cur==i.yearMD}" @click="init(i)">
          <span>{{ i.day }}</span>
          <p class="date">{{i.date}}</p>
        </div>
      </div>
    </div>
    <div class="search">
      <a-input-search type="text" placeholder="搜索"  v-model='search' @search="getList(cur)" class="ipt"/>
    </div>
    <div class="ul">
      <div class="scroll">
        <div class="a" v-for="i in list" :class="{'over':i.is_complete==1}" @click='see(i.id,0)'>
          <span>{{i.title}}</span>
          <div class="time">{{ i.remind_time | Ym }}</div>
        </div>  
      </div>
    </div>
  </div>
</template>
<script>
  import Ntxt from '@/components/textarea/ntxt'
  import getDateFn from '../date'
  import Month from '@/components/month'
  import { todoInfo, todoUpdate ,todoOk } from '@/server/api'
  export default {
    name:'Dealt',
    components:{ Month,Ntxt },
    data(){
      return {
        cur:0,
        is_complete:0,
        putVisible:false,
        form: {
          content: '',
          title: ''
        },
        search:'',
        rules:{},
        edit:0,
        week:[],
        list:[],
      }
    },
    computed:{
      message(){
        return this.$store.state.Home.message
      }
    },
    filters:{
      Ym(val){
        let date=new Date(val)
        return date.getFullYear()+'年'+(date.getMonth()+1)+'月' 
      }
    },
    created(){
      let start=getDateFn.getMonday('s')
      let end=getDateFn.getMonday('e')
      let week=getDateFn.getAllDate(start,end)
      this.cur=getDateFn.getDate()
      this.getList(getDateFn.getDate())
      this.week=week
    },
    methods:{
      see(id, type) {
        this.edit = type;
        todoInfo({ id: id }, 0).then(e => {
          this.form = {
              id: e.id,
              title: e.title,
              content: e.content,
              remind_time: e.remind_time
          }
          this.is_complete=e.is_complete
          this.putVisible = true
        })
      },
      isok(id) {
        todoOk({ id: id }).then(e => {
          this.$message.success('已标记完成')
          this.rest()
          this.getList(this.cur)
        })
      },
      confirm() {
        let form = JSON.parse(JSON.stringify(this.form))
        let disform = {
          title: form.title,
          content: form.content,
          remind_time: form.remind_time
        }
        this.$refs.forms.validate(valid => {
          if (valid) {
            disform.id = form.id
            todoUpdate(disform, 1).then(e => {
              this.$message.success('编辑成功')
              this.getList(this.cur)
              this.rest()
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        })
      },
      rest() {
        let form = JSON.parse(JSON.stringify(this.form))
        for (let val in form) {
          form[val] = ''
        }
        this.form = form
        this.putVisible=false;
      },
      more(){
        this.$refs.monthbox.visible=true;
        this.$refs.monthbox.init()
      },
      getList(date){
        const data={
          content:this.search,
          start_date:date,
          end_date:date,
          limit:100,
          page:1
        }
        this.$Ajax({
          url:'todo/index',
          data:data,
          type: "get",
        }).then(e=>{
          this.list=e.list
        })
      },
      init(item){
        this.cur=item.yearMD
        this.getList(item.yearMD)
      }
    } 
  }
</script>
<style lang="less" scoped>
.ipt{
  /deep/ .ant-input{
    border:0 none;
    background: none;
    box-shadow: none;
  }
  /deep/  .ant-input-suffix{
      display: none;
  }
}
.dealtbox{
  background: linear-gradient(180deg, #E1EDFF 0%, #FFFFFF 100%);
  filter: blur(0px);
  padding:10px;
  .html{

    margin-top: 10px;
    border-bottom:1px solid #DDD;
    margin-bottom:9px;
    .a{
      font-size: 0.875rem;
      font-weight: normal;
      color: #66707C;
      line-height: 32px;
      white-space:nowrap;
      overflow:hidden;
      text-overflow:ellipsis;
    }
  }
  .nomess{
    margin-top: 10px;
    margin-bottom:10px;
    line-height: 32px;
    font-size: 0.875rem;
    font-weight: normal;
    color: #666;
  }
  .month{
    border:1px solid #EFEFEF;
    background:#fff;
    padding:8px 0;
    height: 96px;
    .tp{
      display:flex;
      justify-content:space-between;
      align-items:center;
      padding:0 10px;
      margin-bottom:12px;
      span{
        font-weight: bold;
        color: #0E2949;
        line-height: 17px;
        font-size: 0.875rem;
      }
      a{
        font-size: 0.75rem;
        color: #9FA8B3;
        line-height: 13px;
      }
    }
    .week{
      display:flex;
      .li{
        margin:0 10px;
        display:flex;
        flex:1;
        flex-direction:column;
        align-items:center;
        justify-content:center;
        padding:3px 0;
        height:50px;
        cursor: pointer;
        span{
          font-size: 0.75rem;
          color: #9FA8B3;
          line-height: 18px;
        }
        .date{
          font-size: 0.875rem;
          font-weight: 500;
          color: #0E2949;
          line-height: 20px;
          margin:0;
        }
      }
      .now{
        background:#1D8BFE;
        border-radius: 13px;
        span{
          color:#fff;
        }
        .date{
          color:#fff;
        }
      }
    }
  }
  .search{
    line-height:28px;
    border-bottom: 1px solid #EFEFEF;
    background:url('../../../assets/img/icon-search@2x.png') no-repeat left 8px;
    background-size:14px 14px;
    padding-left:16px;
    input{
      border:0 none;
      background:none;
      width:100%;
      line-height:20px;
      font-size: 0.75rem;
      color: #9FA8B3;
    }
  }
  .ul{
    margin-top:8px;
    padding-right: 10px;
    height: 112px;
    overflow-y: auto;
    .scroll{
    
    }
    .a{
      font-size: 0.875rem;
      color: #0E2949;
      line-height: 20px;
      display:flex;
      justify-content:space-between;
      align-items:center;
      margin-bottom:8px;
      padding-left:14px;
      background:url('../../../assets/img/ck.png') no-repeat left center;
      background-size:12px 12px;
      cursor:pointer;
      transition-duration: 500ms;
      span{
        color:#f00;
      }
      &:hover{
        color:#1D8BFE;
      }
      &:nth-last-child(1){
        margin:0;
      }
      .time{
        color: #9FA8B3;
      }
    }
    .over{
      text-decoration:line-through;
      background:url('../../../assets/img/cked.png') no-repeat left center;
      background-size:12px 12px;
      color:#9FA8B3!important;
    }
  }
}
</style>